import React, { useState, useEffect } from 'react'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import Dropdown from '@jimmyboys/liita-ui/dist/components/Dropdown'
import TextInput from '@jimmyboys/liita-ui/dist/components/TextInput'
import styles from './JustificationField.module.sass'

const MAX_LENGTH = 500

export const JustificationField = ({
	justifications = [],
	providerName,
	onJustificationChange = () => {},
	onCancel,
}) => {
	const { i18n } = useGlobal()
	const [selectedJustification, setSelectedJustification] = useState(null)
	const [otherText, setOtherText] = useState('')

	const outrosJustification = justifications.find(
		(j) =>
			j.justificationName?.toLowerCase() === 'outros' ||
			j.justificationName?.toLowerCase() === 'others' ||
			j.justificationName?.toLowerCase() === 'outro'
	)

	const justificationOptions = justifications.map((j) => ({
		value: j.justificationId,
		text: j.justificationName,
	}))

	useEffect(() => {
		setSelectedJustification(null)
		setOtherText('')
		onJustificationChange(null)
	}, [providerName])

	useEffect(() => {
		if (!selectedJustification) {
			onJustificationChange(null)
			return
		}
		const isOutros =
			selectedJustification === outrosJustification?.justificationId
		if (isOutros && !otherText.trim()) {
			onJustificationChange(null)
			return
		}
		if (isOutros && otherText.trim().length > MAX_LENGTH) {
			onJustificationChange(null)
			return
		}
		if (isOutros) {
			onJustificationChange({
				justificationId: selectedJustification,
				justificationName: otherText,
			})
		} else {
			const justificationName =
				justifications.find(
					(j) => j.justificationId === selectedJustification
				)?.justificationName || selectedJustification
			onJustificationChange({
				justificationId: selectedJustification,
				justificationName,
			})
		}
	}, [selectedJustification, otherText])

	const handleDropdownChange = (value) => {
		const id = value?.target?.value ?? value
		setSelectedJustification(id)
	}

	const handleCancel = () => {
		onCancel()
	}

	const isOutrosSelected =
		selectedJustification === outrosJustification?.justificationId

	const outrosError =
		isOutrosSelected && otherText.trim().length > MAX_LENGTH
			? i18n`otherJustificationMaxLength`
			: null

	return (
		<div className={styles['justification-field']}>
			<h4 className={styles['title']}>{i18n`Justification`}</h4>
			<div className={styles['field']}>
				<Dropdown
					value={selectedJustification}
					onChange={handleDropdownChange}
					options={justificationOptions}
					optionsAlign='left'
					noData={i18n`No results`}
				/>
			</div>
			{isOutrosSelected && (
				<div className={styles['field']}>
					<TextInput
						value={otherText}
						onChange={(e) => setOtherText(e?.target?.value ?? e)}
						placeholder={i18n`otherJustificationPlaceholder`}
						multiline
						rows={3}
					/>
					<div className={styles['char-counter']}>
						{otherText.length}/{MAX_LENGTH}
					</div>
					{outrosError && (
						<p className={styles['error-text']}>{outrosError}</p>
					)}
				</div>
			)}
		</div>
	)
}

export default JustificationField
